// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"client-portal-routes_mainContainer__5dFm6","contentContainer":"client-portal-routes_contentContainer__9+Wcc"};